<template>
	<v-container class="pa-0" v-if="visibleTotals.length">
		<v-row class="ma-0" justify="center">
			<v-col class="pa-0" v-for="total in visibleTotals" :key="total.value" lg="3" md="4" sm="6">
				<v-list two-line class="background-2 w100p">
					<v-list-item>
						<v-list-item-action v-if="total.icon">
							<v-icon :color="total.color || 'primary'">{{ total.icon }}</v-icon>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>{{ total.text }}</v-list-item-title>
							<v-list-item-subtitle>{{ formatValue(total) }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

	export default {
		name: 'totals-footer',

		props: {
			// Totali calcolati dal backend sull'intero set filtrato
			totals: Object,
			// Definizioni dichiarate dal modello (totalsDefs): testo, icona, formato
			defs: Array,
		},

		computed: {
			visibleTotals() {
				if(!this.totals || !this.defs) {
					return []
				}

				return this.defs.filter(def => this.totals[def.value] !== undefined && this.totals[def.value] !== null)
			},
		},

		methods: {
			formatValue(def) {
				const value = this.totals[def.value]

				switch (def.type) {
					case 'duration':
						return this.$options.filters.duration(value)
					case 'currency':
						return this.$options.filters.currency(value, 2)
					default:
						return value
				}
			},
		},
	}
</script>
